<cb-dialog>
    <form #form="ngForm">
        <mat-label>Type of Hold</mat-label>
        @for (hold of availableHolds; track hold) {
            <cb-checkbox
                [name]="'tradeType' + hold.holdAction + '-' + hold.holdType"
                [label]="hold.label"
                [ngModel]="isAccountHoldChecked(hold.holdAction, hold.holdType)"
                (change)="onAccountHoldChanged(hold.holdAction, hold.holdType, $event)"
            ></cb-checkbox>
        }
        <cb-text-area
            label="Description"
            name="description"
            [maxlength]="1000"
            [required]="true"
            [(ngModel)]="description"
        ></cb-text-area>
    </form>
    <div actions>
        <span class="flex"></span>
        <button
            mat-raised-button
            color="primary"
            [disabled]="!form.dirty || !form.valid || !canSave()"
            (click)="onSaveClicked()"
        >
            Save
        </button>
        <button mat-raised-button (click)="dialogRef.close()">Cancel</button>
    </div>
</cb-dialog>
